export default __webpack_public_path__ + "static/media/500.3b43df42.jpg";